import { render } from "./QuestionareResult.vue?vue&type=template&id=715ac563&scoped=true"
import script from "./QuestionareResult.vue?vue&type=script&lang=js"
export * from "./QuestionareResult.vue?vue&type=script&lang=js"

import "./QuestionareResult.vue?vue&type=style&index=0&id=715ac563&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-715ac563"

export default script